import { TOfferwallType } from "./offerwall-type";

export enum GroupOffersBy {
    PLAIN = "plain",
    PARTNERS = "partners",
    COUNTRIES = "countries"
}

export interface GroupOffersByQuery {
    groupBy: GroupOffersBy;
    showHidden: boolean;
}

export interface ShowHiddenOffersQuery {
    showHidden: boolean;
}

export interface TOffer {
    id: number;
    name: string;
    partnerId: string;
    graphicFolder: string;
    geo: string;
    caption: string;
    hidden?: boolean;
    link?: string;
    graphic?: {
        logo: string;
        bg: string;
    };
    generatedKey?: string;
    offerwallType?: TOfferwallType;
    texts?: string[];
    boolean1?: boolean;
    noBackground?: boolean;
    emoji?: string;
}

export interface TPartner {
    id: number;
    name: string;
    partnerId: string;
}

export interface IOfferState {
    offerId: number;
    hidden: boolean;
}

export interface IAppOffersSection {
    sectionId: number;
    offerStatesOrdered: { [key: string]: IOfferState[] };
}

export interface ISectionsList {
    id: number;
    name?: string;
    content: IAppOffersSection[];
    offerwallType?: TOfferwallType;
}

export interface IOffersAdminResponse {
    plain: TOffer[];
    partners: TPartner[];
    byPartners: { [key: string]: TOffer[] };
    byCountries: { [key: string]: TOffer[] };
}
